import React from 'react';
import { LessonHomeworkSubmissionShowView } from '../../../types/lesson_homework_submissions';
import './reviewPlaceholder.module.scss';
import { ExamPracticalSectionSubmissionShowView } from '../../../types/exam_sections';

type Props = {
    submission: LessonHomeworkSubmissionShowView | ExamPracticalSectionSubmissionShowView;
};

export const ReviewPlaceholder = ({ submission }: Props) => {
    if (submission.review_completed_at) {
        return null;
    }
    return (
        <div styleName="review-placeholder" id="review-placeholder">
            {submission.reviewer
                ? '採点完了までもう少々お待ちください。'
                : '現在担当者をアサインしておりますので、もう少々お待ちください。'}
        </div>
    );
};
